export default __webpack_public_path__ + "fonts/vlg-corporate-logo.svg";